import LabeledTitle from '../../../components/LabeledTitle'
import React from 'react'
import CourtCase from './CourtCase'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'

export default function CriminalCases({ data }: { data: any }) {
  return (
    <>
      <LabeledTitle title={'刑事案件检测'} />
      <ExpandableListWrapper
        isEmpty={(data?.court_case_info?.criminal ?? []).length === 0 || data?.court_case_info?.criminal === undefined}
      >
        {(data?.court_case_info?.criminal ?? []).map((item: any, index: number) => {
          return <CourtCase number={index + 1} key={index} item={item} />
        })}
      </ExpandableListWrapper>
    </>
  )
}
